import React, { useContext, useEffect, useState } from "react";
import "./CreatePRopesoal.css";
import Application from "../../../StateContext/Application.js";
import {
  Back32,
  Cancel32,
  ProposalCreation32,
  submit,
} from "../../../../../public/LoginImages/importimages.js";
import { useNavigate } from "react-router-dom";
import exifr from "exifr";
import * as XLSX from "xlsx";
import { apiurl } from "../../../../../path.js";
import { useLanguage } from "../../../../../lang/langcontext/LanguageContext.js";
import GooglePagination from "../../../styles/GooglePagination.js";
import validateFile from '../../../../../utils/fileUploadHelper.js';

const CreateProposalStatewise = () => {
  const { language, toggleLanguage, t } = useLanguage();
  const nav = useNavigate();

  const operation = useContext(Application);
  const { ProposalCreation, SecureFileFetching, GetMyDepartmentAccess } = operation;
  const [showAll, setShowAll] = useState(false);

  const [tableData, setTableData] = useState([]);

  const [filteredBills, setFilteredBills] = useState([]);
  const [TotalProposalAmount, setTotalProposalAmount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);

  const billsPerPage = 10;
  const totalPages = showAll
    ? 1
    : Math.ceil(filteredBills.length / billsPerPage);
  const indexOfLastBill = currentPage * billsPerPage;
  const indexOfFirstBill = indexOfLastBill - billsPerPage;
  const currentBills = showAll
    ? filteredBills
    : filteredBills?.slice(indexOfFirstBill, indexOfLastBill);

  const [data, setData] = useState({
    HeadCode: "2515_1238 - MLA Representative",
    HeadName: "2515-1238(MLA Representative)",
    ProposalYear: "",
    SchemeName: "",
    District: "",
    Taluka: "",
    ConstituencyName: "",
    GramPanchayat: "",
    WorkName: "",
    ProposalFileNumber: "",
    ProposalAmount: "",
    Area: "",
    Type: "State",
  });

  const [loading, setLoading] = useState(false);

  const [myDepartments, setMyDepartments] = useState([]);
  const [departmentId, setDepartmentId] = useState("");
  const departmentRequired = myDepartments.length > 0;
  
  useEffect(() => {
    (async () => {
      try {
        const r = await GetMyDepartmentAccess();
        const list = r?.data?.departments || [];
        setMyDepartments(list);
        if (list.length === 1) setDepartmentId(String(list[0].id));   // only one -> automatic
      } catch (e) {
        console.error("GetMyDepartmentAccess failed", e);
      }
    })();
  }, []);
  
  // changing the department clears an already loaded Excel (it belongs to the old choice)
  const handleDepartmentChange = (e) => {
    setDepartmentId(e.target.value);
    setTableData([]);
    setFilteredBills([]);
    setTotalProposalAmount(0);
    setCurrentPage(1);
    const f = document.getElementById("ExcelFile");
    if (f) f.value = "";
  };

  const CancelMapSubmission = (e) => {
    e.preventDefault();
    try {
      setTableData([]);
      setFilteredBills([]);
      alert("Proposal Cancelled !!");
      window.location.reload();
    } catch (err) {
      console.log("Error : ", err);
    }
  };

  // Excel
    const handleFileUpload = async (e) => {
        e.preventDefault();
        const fileInput = e.target;   // add this line
        setLoading(true);

        try {
            const file = e.target.files[0];
            if (!file) {
                alert("Please select a file");
                setLoading(false);
                return;
            }

            const XLS_TYPE = "application/vnd.ms-excel"; // .xls
            const XLSX_TYPE = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

            // ❌ Block XLSX explicitly
            // if (file.type === XLSX_TYPE || file.name.toLowerCase().endsWith(".xlsx")) {
            //     alert("❌ .xlsx files are not supported. Please upload .xls file only.");
            //     e.target.value = "";
            //     setLoading(false);
            //     return;
            // }

            // ❌ Block macro Excel
            if (file.name.toLowerCase().endsWith(".xlsm")) {
                alert("❌ Macro-enabled Excel (.xlsm) is not allowed.");
                e.target.value = "";
                setLoading(false);
                return;
            }

            // ❌ Block anything other than .xls & .xlsx
            if (file.type !== XLS_TYPE && file.type !== XLSX_TYPE) {
                const fileName = file.name.toLowerCase();
                if (!fileName.endsWith(".xls") && !fileName.endsWith(".xlsx")) {
                    alert("❌ Invalid file type. Only .xls & .xlsx files are allowed.");
                    e.target.value = "";
                    setLoading(false);
                    return;
                }
            }

            // ✅ VALID .xls FILE
            const reader = new FileReader();

            reader.onload = (evt) => {
    const binaryStr = evt.target.result;
    try {
        const workbook = XLSX.read(binaryStr, { type: 'binary' });
        const worksheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[worksheetName];
        const jsonData = XLSX.utils.sheet_to_json(worksheet);

        console.log('Parsed Excel Data:', jsonData);

        const normalizedData = jsonData.map(row => {
            const newRow = {};
            Object.keys(row).forEach(key => {
                newRow[key.trim()] = row[key];
            });
            newRow.__rowNum__ = row.__rowNum__;   // add this line
            return newRow;
        });

        // ===== VALIDATE Job_ID is numeric BEFORE building formattedData =====
        // const invalidJobIdRows = normalizedData
        //     .map((row, i) => ({ row, i }))
        //     .filter(({ row }) => row['Job_ID'] && isNaN(Number(row['Job_ID'])));

        // if (invalidJobIdRows.length > 0) {
        //     const details = invalidJobIdRows
        //         .map(({ row, i }) => `Row ${i + 1} (Work Name: ${row['Work Name'] || 'N/A'}): "${row['Job_ID']}"`)
        //         .join('\n');

        //     alert(
        //         `❌ Job_ID must be a valid number. Please fix the following row(s) in your Excel file:\n\n${details}`
        //     );
        //     setLoading(false);
        //     return;
        // }
        // ===== VALIDATE Job_ID =====
const JOB_ID_MAX_DIGITS = 10; // set this to your DB column limit

const jobIdErrors = [];
const seenJobIds = new Map(); // numeric value -> first Excel row

normalizedData.forEach((row, i) => {
    const excelRow = (row.__rowNum__ ?? i + 1) + 1; // real Excel row number
    const jobId = String(row['Job_ID'] ?? '').trim();
    const workName = row['Work Name'] || 'N/A';
    const where = `Row ${excelRow} (Work Name: ${workName})`;

    if (!jobId) {
        jobIdErrors.push(`${where}: Job_ID is empty`);
        return;
    }
    if (!/^\d+$/.test(jobId)) {
        jobIdErrors.push(`${where}: Job_ID "${jobId}" must contain digits only (no decimals, spaces, minus sign or text)`);
        return;
    }
    if (jobId.length > JOB_ID_MAX_DIGITS) {
        jobIdErrors.push(`${where}: Job_ID is too long (${jobId.length}/${JOB_ID_MAX_DIGITS} digits)`);
        return;
    }
    if (Number(jobId) === 0) {
        jobIdErrors.push(`${where}: Job_ID cannot be 0`);
        return;
    }

    // Duplicate check inside the file ("007" and "7" count as the same ID)
    const key = String(Number(jobId));
    if (seenJobIds.has(key)) {
        jobIdErrors.push(`${where}: Duplicate Job_ID ${key} (already used in row ${seenJobIds.get(key)})`);
    } else {
        seenJobIds.set(key, excelRow);
    }
});

if (jobIdErrors.length > 0) {
    const shown = jobIdErrors.slice(0, 10).join('\n');
    const more = jobIdErrors.length > 10 ? `\n...and ${jobIdErrors.length - 10} more` : '';
    alert(`❌ Please fix the Job_ID in your Excel file:\n\n${shown}${more}`);
    fileInput.value = ""; // lets the user re-select the corrected file
    setLoading(false);
    return;
}
// =====================================================================
        // =====================================================================

        // ===== VALIDATE Proposal Amount is numeric BEFORE building formattedData =====
const isValidAmount = (val) =>
    val !== null && val !== undefined && val !== "" &&
    /^\d+(\.\d+)?$/.test(String(val).trim());

const invalidAmountRows = normalizedData
    .map((row, i) => ({ row, i }))
    .filter(({ row }) => row['Proposal Amount'] && !isValidAmount(row['Proposal Amount']));

if (invalidAmountRows.length > 0) {
    const details = invalidAmountRows
        .map(({ row, i }) => `Row ${i + 1} (Work Name: ${row['Work Name'] || 'N/A'}): "${row['Proposal Amount']}"`)
        .join('\n');

    alert(
        `❌ Proposal Amount must be a valid number (no text or symbols). Please fix the following row(s) in your Excel file:\n\n${details}`
    );
    setLoading(false);
    return;
}
// =====================================================================

        const formattedData = normalizedData
            .filter(row =>
                row['Proposal Year'] &&
                row['District'] &&
                row['Taluka'] &&
                row['Constituency Name'] &&
                row['Gram Panchayat'] &&
                row['Work Name'] &&
                row['Job_ID'] &&
                row['Proposal File Number'] &&
                row['Proposal Amount'] &&
                row['Class Of Work'] &&
                row['Type of Work'] &&
                row['Road Category'] &&
                row['Road Number'] &&
                row['Proposed Length'] &&
                row['Remark']
            )
            .map(row => {
                let gp = row['Gram Panchayat'];
                let isMultiple = "No";

                try {
                    if (typeof gp === 'string' && gp.startsWith('[')) gp = JSON.parse(gp);
                } catch {
                    gp = [gp];
                }

                if (!Array.isArray(gp)) gp = [gp];
                isMultiple = gp.length > 1 ? "Yes" : "No";

                return {
                    HeadCode: "2515-1238(MLA Representative)",
                    ProposalYear: row['Proposal Year'],
                    District: row['District'],
                    Taluka: row['Taluka'],
                    ConstituencyName: row['Constituency Name'],
                    isMultipleGp: isMultiple,
                    GramPanchayat: gp,
                    WorkName: row['Work Name'],
                    JOB_ID: Number(row['Job_ID']),   // ← cast to number here
                    ProposalFileNumber: row['Proposal File Number'],
                    ProposalAmount: row['Proposal Amount'],
                    Type: "State",
                    workClass: row['Class Of Work'],
                    workType: row['Type of Work'],
                    RoadCategory: row['Road Category'],
                    RoadNumber: row['Road Number'],
                    proposedLength: row['Proposed Length'],
                    Remark: row['Remark']
                }
            });

        console.log("Formatted Data:", formattedData);


        // ===== VALIDATE Work Name =====
const WORK_NAME_MIN = 5;
const WORK_NAME_MAX = 250; // set this to your DB column size

// Letters (English + Marathi), digits, spaces and common punctuation only
const WORK_NAME_ALLOWED = /^[\p{L}\p{M}\p{N}\s.,\-_/()&'":;%+#@]+$/u;
const ONLY_NUMBERS_OR_SYMBOLS = /^[\p{N}\s\p{P}\p{S}]+$/u;

const workNameErrors = [];
const seenNames = new Map(); // key -> first Excel row

normalizedData.forEach((row, i) => {
    const excelRow = (row.__rowNum__ ?? i + 1) + 1; // real Excel row number
    const name = String(row['Work Name'] ?? '').replace(/\s+/g, ' ').trim();

    if (!name) {
        workNameErrors.push(`Row ${excelRow}: Work Name is empty`);
        return;
    }
    if (name.length < WORK_NAME_MIN) {
        workNameErrors.push(`Row ${excelRow}: Work Name is too short (minimum ${WORK_NAME_MIN} characters)`);
    }
    if (name.length > WORK_NAME_MAX) {
        workNameErrors.push(`Row ${excelRow}: Work Name is too long (${name.length}/${WORK_NAME_MAX} characters)`);
    }
    if (ONLY_NUMBERS_OR_SYMBOLS.test(name)) {
        workNameErrors.push(`Row ${excelRow}: Work Name cannot contain only numbers or symbols`);
    } else if (!WORK_NAME_ALLOWED.test(name)) {
        workNameErrors.push(`Row ${excelRow}: Work Name contains invalid characters (e.g. < > { } [ ] | \\ ^ ~ \`)`);
    }

    // Duplicate check inside the file (same name + district + taluka + gram panchayat)
    const key = [name, row['District'], row['Taluka'], JSON.stringify(row['Gram Panchayat'])]
        .map((v) => String(v ?? '').trim().toLowerCase())
        .join('|');
    if (seenNames.has(key)) {
        workNameErrors.push(`Row ${excelRow}: Duplicate Work Name (same as row ${seenNames.get(key)})`);
    } else {
        seenNames.set(key, excelRow);
    }
});

if (workNameErrors.length > 0) {
    const shown = workNameErrors.slice(0, 10).join('\n');
    const more = workNameErrors.length > 10 ? `\n...and ${workNameErrors.length - 10} more` : '';
    alert(`❌ Please fix the Work Name in your Excel file:\n\n${shown}${more}`);
    fileInput.value = ""; // lets the user re-select the corrected file
    setLoading(false);
    return;
}
// =====================================================================

        const totalAmount = formattedData.reduce(
            (sum, item) => sum + Number(item.ProposalAmount || 0),
            0
        );

        setTotalProposalAmount(totalAmount);
        setTableData(formattedData);
        setFilteredBills(formattedData);
        setLoading(false);

    } catch (parseErr) {
        console.error("Error parsing Excel file:", parseErr);
        alert("Invalid Excel format. Please check your file headers.");
        setLoading(false);
    }
};

            reader.readAsBinaryString(file);

        } catch (error) {
            console.error("File upload error:", error);
            alert("❌ File upload failed");
            setLoading(false);
        }
    };

//   const handleFileUpload = async (e) => {
//     e.preventDefault();
//     setLoading(true);

//     try {
//       const file = e.target.files[0];
//       if (!file) {
//         alert("Please select a file");
//         setLoading(false);
//         return;
//       }

//       const XLS_TYPE = "application/vnd.ms-excel"; // .xls
//       const XLSX_TYPE =
//         "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

//       // ❌ Block XLSX explicitly
//       // if (file.type === XLSX_TYPE || file.name.toLowerCase().endsWith(".xlsx")) {
//       //     alert("❌ .xlsx files are not supported. Please upload .xls file only.");
//       //     e.target.value = "";
//       //     setLoading(false);
//       //     return;
//       // }

//       // ❌ Block macro Excel
//       if (file.name.toLowerCase().endsWith(".xlsm")) {
//         alert("❌ Macro-enabled Excel (.xlsm) is not allowed.");
//         e.target.value = "";
//         setLoading(false);
//         return;
//       }

//       // ❌ Block anything other than .xls & .xlsx
//       if (file.type !== XLS_TYPE && file.type !== XLSX_TYPE) {
//         const fileName = file.name.toLowerCase();
//         if (!fileName.endsWith(".xls") && !fileName.endsWith(".xlsx")) {
//           alert("❌ Invalid file type. Only .xls & .xlsx files are allowed.");
//           e.target.value = "";
//           setLoading(false);
//           return;
//         }
//       }

//       // ✅ VALID .xls FILE
//       const reader = new FileReader();

//       reader.onload = (evt) => {
//         const binaryStr = evt.target.result;
//         try {
//           const workbook = XLSX.read(binaryStr, { type: "binary" });
//           const worksheetName = workbook.SheetNames[0];
//           const worksheet = workbook.Sheets[worksheetName];
//           const jsonData = XLSX.utils.sheet_to_json(worksheet);

//           console.log("Parsed Excel Data:", jsonData);

//           const normalizedData = jsonData.map((row) => {
//             const newRow = {};
//             Object.keys(row).forEach((key) => {
//               newRow[key.trim()] = row[key];
//             });
//             return newRow;
//           });

//           // ===== VALIDATE Job_ID is numeric BEFORE building formattedData =====
//           const invalidJobIdRows = normalizedData
//             .map((row, i) => ({ row, i }))
//             .filter(({ row }) => row["Job_ID"] && isNaN(Number(row["Job_ID"])));

//           if (invalidJobIdRows.length > 0) {
//             const details = invalidJobIdRows
//               .map(
//                 ({ row, i }) =>
//                   `Row ${i + 1} (Work Name: ${row["Work Name"] || "N/A"}): "${row["Job_ID"]}"`,
//               )
//               .join("\n");

//             alert(
//               `❌ Job_ID must be a valid number. Please fix the following row(s) in your Excel file:\n\n${details}`,
//             );
//             setLoading(false);
//             return;
//           }
//           // =====================================================================


//           // ===== VALIDATE Proposal Amount is numeric BEFORE building formattedData =====
// const isValidAmount = (val) =>
//     val !== null && val !== undefined && val !== "" &&
//     /^\d+(\.\d+)?$/.test(String(val).trim());

// const invalidAmountRows = normalizedData
//     .map((row, i) => ({ row, i }))
//     .filter(({ row }) => row['Proposal Amount'] && !isValidAmount(row['Proposal Amount']));

// if (invalidAmountRows.length > 0) {
//     const details = invalidAmountRows
//         .map(({ row, i }) => `Row ${i + 1} (Work Name: ${row['Work Name'] || 'N/A'}): "${row['Proposal Amount']}"`)
//         .join('\n');

//     alert(
//         `❌ Proposal Amount must be a valid number (no text or symbols). Please fix the following row(s) in your Excel file:\n\n${details}`
//     );
//     setLoading(false);
//     return;
// }
// // =====================================================================

//           const formattedData = normalizedData
//             .filter(
//               (row) =>
//                 row["Proposal Year"] &&
//                 row["District"] &&
//                 row["Taluka"] &&
//                 row["Constituency Name"] &&
//                 row["Gram Panchayat"] &&
//                 row["Work Name"] &&
//                 row["Job_ID"] &&
//                 row["Proposal File Number"] &&
//                 row["Proposal Amount"] &&
//                 row["Class Of Work"] &&
//                 row["Type of Work"] &&
//                 row["Road Category"] &&
//                 row["Road Number"] &&
//                 row["Proposed Length"] &&
//                 row["Remark"],
//             )
//             .map((row) => {
//               let gp = row["Gram Panchayat"];
//               let isMultiple = "No";

//               try {
//                 if (typeof gp === "string" && gp.startsWith("["))
//                   gp = JSON.parse(gp);
//               } catch {
//                 gp = [gp];
//               }

//               if (!Array.isArray(gp)) gp = [gp];
//               isMultiple = gp.length > 1 ? "Yes" : "No";

//               return {
//                 HeadCode: "2515-1238(MLA Representative)",
//                 ProposalYear: row["Proposal Year"],
//                 District: row["District"],
//                 Taluka: row["Taluka"],
//                 ConstituencyName: row["Constituency Name"],
//                 isMultipleGp: isMultiple,
//                 GramPanchayat: gp,
//                 WorkName: row["Work Name"],
//                 JOB_ID: Number(row["Job_ID"]), // ← cast to number here
//                 ProposalFileNumber: row["Proposal File Number"],
//                 ProposalAmount: row["Proposal Amount"],
//                 Type: "State",
//                 workClass: row["Class Of Work"],
//                 workType: row["Type of Work"],
//                 RoadCategory: row["Road Category"],
//                 RoadNumber: row["Road Number"],
//                 proposedLength: row["Proposed Length"],
//                 Remark: row["Remark"],
//               };
//             });

//           console.log("Formatted Data:", formattedData);

//           const totalAmount = formattedData.reduce(
//             (sum, item) => sum + Number(item.ProposalAmount || 0),
//             0,
//           );

//           setTotalProposalAmount(totalAmount);
//           setTableData(formattedData);
//           setFilteredBills(formattedData);
//           setLoading(false);
//         } catch (parseErr) {
//           console.error("Error parsing Excel file:", parseErr);
//           alert("Invalid Excel format. Please check your file headers.");
//           setLoading(false);
//         }
//       };

//       //--> old code
//       // reader.onload = (evt) => {
//       //     const binaryStr = evt.target.result;
//       //     try {
//       //         const workbook = XLSX.read(binaryStr, { type: 'binary' });
//       //         const worksheetName = workbook.SheetNames[0];
//       //         const worksheet = workbook.Sheets[worksheetName];
//       //         const jsonData = XLSX.utils.sheet_to_json(worksheet);

//       //         console.log('Parsed Excel Data:', jsonData);

//       //         const formattedData = jsonData
//       //             .filter(row =>
//       //                 row['Proposal Year'] &&
//       //                 row['District'] &&
//       //                 row['Taluka'] &&
//       //                 row['Constituency Name'] &&
//       //                 row['Gram Panchayat'] &&
//       //                 row['Work Name'] &&
//       //                 row['Proposal File Number'] &&
//       //                 row['Proposal Amount'] &&
//       //                 row['Class Of Work'] &&
//       //                 row['Type of Work'] &&
//       //                 row['Road Category'] &&
//       //                 row['Road Number'] &&
//       //                 row['Proposed Length'] &&
//       //                 row['Remark']
//       //             ).
//       //             map(row => {

//       //                 let gp = row['Gram Panchayat'];
//       //                 let isMultiple = "No";

//       //                 try {
//       //                     if (typeof gp === 'string' && gp.startsWith('[')) gp = JSON.parse(gp);
//       //                 }
//       //                 catch {
//       //                     gp = [gp];
//       //                 }

//       //                 if (!Array.isArray(gp)) gp = [gp];

//       //                 if (gp.length > 1) {
//       //                     isMultiple = "Yes";
//       //                 } else {
//       //                     isMultiple = "No";
//       //                 }

//       //                 return {
//       //                     HeadCode: "2515-1238(MLA Representative)",
//       //                     ProposalYear: row['Proposal Year'],
//       //                     District: row['District'],
//       //                     Taluka: row['Taluka'],
//       //                     ConstituencyName: row['Constituency Name'],
//       //                     isMultipleGp: isMultiple,
//       //                     GramPanchayat: gp,
//       //                     WorkName: row['Work Name'],
//       //                     ProposalFileNumber: row['Proposal File Number'],
//       //                     ProposalAmount: row['Proposal Amount'],
//       //                     Type: "State",
//       //                     workClass: row['Class Of Work'],
//       //                     workType: row['Type of Work'],
//       //                     RoadCategory: row['Road Category'],
//       //                     RoadNumber: row['Road Number'],
//       //                     proposedLength: row['Proposed Length'],
//       //                     Remark: row['Remark']
//       //                 }
//       //             });

//       //         const invalidCount = jsonData.length - formattedData.length;
//       //         // if (invalidCount > 0) {
//       //         //     alert(`${invalidCount} invalid rows were skipped.`);
//       //         // }

//       //         console.log("Formatted Data:", formattedData);

//       //         const totalAmount = formattedData.reduce(
//       //             (sum, item) => sum + Number(item.ProposalAmount || 0),
//       //             0
//       //         );

//       //         setTotalProposalAmount(totalAmount);

//       //         // You can now use `formattedData` e.g. store it in state:
//       //         // setData(formattedData);
//       //         setTableData(formattedData);
//       //         setFilteredBills(formattedData);
//       //         setLoading(false);

//       //     } catch (parseErr) {
//       //         console.error("Error parsing Excel file:", parseErr);
//       //         alert("Invalid Excel format. Please check your file headers.");
//       //         setLoading(false);
//       //     }
//       // };

//       reader.readAsBinaryString(file);
//     } catch (error) {
//       console.error("File upload error:", error);
//       alert("❌ File upload failed");
//       setLoading(false);
//     }
//   };

  const handleSupportingDocUpload = async (e) => {
    const file = e.target.files[0];

    if (!file) return;

    const validation = validateFile(file, 2);
 
    if (!validation.valid) {
      alert(validation.message);
      e.target.value = "";
      return;
    }

    // ===== PDF SECURITY CHECK =====
    if (file.type === "application/pdf") {
      const reader = new FileReader();
      reader.onload = (evt) => {
        const buffer = evt.target.result;
        const text = new TextDecoder("latin1").decode(new Uint8Array(buffer));

        const dangerousPatterns = [
          /\/JavaScript\s*<</,
          /\/JS\s*\(/,
          /\/AA\s*<</,
          /\/OpenAction\s*<</,
          /\/Launch\s*<</,
          /\/RichMedia\s*<</,
        ];

        if (dangerousPatterns.some((p) => p.test(text))) {
          alert("⚠️ Malicious PDF detected. Upload blocked.");
          e.target.value = "";
          return;
        }

        console.log("✅ Safe PDF selected");
      };
      reader.readAsArrayBuffer(file);
      return;
    }

    // ===== IMAGE FILE =====
    console.log("✅ Image selected:", file.name);
  };

  const handleBulkSubmit = async (e) => {
    e.preventDefault();
    console.log("Hello function is calaed ");

    let ProposalCopy = document.getElementById("ProposalCopy")?.files;
    let AdditionalSupportingDocument = document.getElementById(
      "AdditionalSupportingDocument",
    )?.files;

    if (tableData.length === 0) {
      return alert("No data Inserted");
    }

    if (departmentRequired && !departmentId) {
      return alert(t("Please select the Department."));
    }

    if (!ProposalCopy || ProposalCopy.length === 0) {
      return alert("Please upload Supporting Document");
    }

    let shouldSubmit = window.confirm("Are you Sure ??");

    if (shouldSubmit) {
      const formData = new FormData();
      setLoading(true);

      try {
        if (ProposalCopy && ProposalCopy[0]) {
          formData.append("ProposalCopy", ProposalCopy[0]);
        }
        if (AdditionalSupportingDocument && AdditionalSupportingDocument[0]) {
          formData.append("AdditionalSuppDoc", AdditionalSupportingDocument[0]);
        }

        formData.append("tableData", JSON.stringify(tableData));
        formData.append("Type", "State");
        formData.append("DepartmentAccessID", departmentId);
        formData.append("TotalProposalAmount", TotalProposalAmount);

        let result = await ProposalCreation(formData);
        console.log(result);

        const { status, message } = result;

        if (status) {
          alert(message);
          window.location.reload();
          setLoading(false);
        } else {
          alert(message);
          setLoading(false);
        }
      } catch (error) {
        console.log(error);
        setLoading(false);
      } finally {
        setLoading(false);
      }
    } else {
      alert("Work Order Edit Operation Cancel !!!");
      setLoading(false);
    }
  };

  return (
    <>
      <div
        style={{
          height: "90vh",
          overflowY: "scroll",
          overflowX: "hidden",
          scrollBehavior: "smooth",
        }}
      >
        <div
          className="col-12"
          style={{ backgroundColor: "#EFF3F8", padding: "2rem 0px 5px 0px" }}
        >
          <div className="col-12 m-auto my-2 budgetContainer">
            <div className="m-auto budgetElement">
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  paddingBottom: "10px",
                }}
              >
                <div>
                  <h5 className=" bg-light">
                    <img src={ProposalCreation32} />
                    {t("Proposal Creation ( State Wise )")}
                  </h5>
                </div>
              </div>
              <p
                className="py-2 ps-1 fw-bold text-danger"
                style={{ backgroundColor: "#FBE7E7" }}
              >
                {t("Note : Fields marked with * are mandatory")}
              </p>

              {loading && (
                <div
                  style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    background: "rgba(255, 255, 255, 0.7)",
                    backdropFilter: "blur(4px)",
                    zIndex: 9999,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      border: "6px solid #f3f3f3",
                      borderTop: "6px solid #007bff",
                      borderRadius: "50%",
                      width: "60px",
                      height: "60px",
                      animation: "spin 1s linear infinite",
                    }}
                  />
                  <style>
                    {`@keyframes spin {0% { transform: rotate(0deg); }100% { transform: rotate(360deg); }}`}
                  </style>
                </div>
              )}

              {departmentRequired && (
  <div className="col-12 elements mb-3">
    <div className="row">
      <div className="col-3 my-auto">
        <label>
          {t("Department")} <span className="text-danger fw-bold">*</span>
        </label>
      </div>
      <div className="col-7">
        <select
          value={departmentId}
          onChange={handleDepartmentChange}
          disabled={myDepartments.length === 1}
          className="form-control py-2"
        >
          <option value="" disabled>{t("Select Department")}</option>
          {myDepartments.map((d) => (
            <option key={d.id} value={String(d.id)}>{d.name}</option>
          ))}
        </select>
      </div>
    </div>
  </div>
)}

              <div className="col-12 my-auto">
                <p className="fw-bold">
                  {t("Proposal ( State wise ) Excel Format :")}
                  {/* <a href={`${apiurl}/ProposalFile/Proposal State wise Excel Format.xlsx`}
                                            target='_blank'>
                                            Link</a> */}

                  <span
                    onClick={(e) => {
                      e.preventDefault();
                      if (departmentRequired && !departmentId) {
                        alert(t("Please select the Department first."));
                        return;
                      }
                      SecureFileFetching(`ProposalFile/Proposal State wise Excel Format.xlsx`);
                    }}
                    className="text-primary"
                    style={{ cursor: "pointer" }}
                  >
                    {t(" Download Link")}
                  </span>
                </p>
              </div>

              <div className="col-12 py-1">
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    console.log("FORM SUBMITTED");
                  }}
                >
                  <div className="col-12 elements">
                    <div className="row">
                      <div className="col-12 my-2">
                        <label>
                          {t("Upload Excel File")}{" "}
                          <span className="text-danger fw-bold">*</span>
                        </label>
                      </div>
                      <div className="col-12">
                        <input
                          id="ExcelFile"
                          disabled={departmentRequired && !departmentId}
                          type="file"
                          className="form-control py-2"
                          style={{
                            backgroundColor: "white",
                            border: "1px solid #ccc",
                          }}
                          accept=".xls,.xlsx"
                          onChange={handleFileUpload}
                        />
                      </div>
                    </div>
                  </div>

                  {tableData && tableData.length > 0 && (
                    <div className="m-auto">
                      <div
                        className="col-12 tableDesign"
                        style={{ background: "#2C78DB", overflowX: "scroll" }}
                      >
                        <table
                          className="m-0 p-0"
                          style={{ width: "100%", borderCollapse: "collapse" }}
                        >
                          <thead>
                            <tr
                              style={{
                                color: "white",
                                border: "none",
                                height: "3rem",
                                fontSize: "12px",
                              }}
                            >
                              <th style={{ minWidth: "80px", padding: "8px" }}>
                                {t("Sr.No")}
                              </th>
                              <th style={{ minWidth: "200px", padding: "8px" }}>
                                {t("Proposal Work Name")}
                              </th>
                              <th style={{ minWidth: "120px", padding: "8px" }}>
                                {t("Job ID")}
                              </th>
                              <th style={{ minWidth: "200px", padding: "8px" }}>
                                {t("Head Code")}
                              </th>
                              <th style={{ minWidth: "150px", padding: "8px" }}>
                                {t("Proposal Year")}
                              </th>
                              <th style={{ minWidth: "120px", padding: "8px" }}>
                                {t("District")}
                              </th>
                              <th style={{ minWidth: "120px", padding: "8px" }}>
                                {t("Taluka")}
                              </th>
                              <th style={{ minWidth: "190px", padding: "8px" }}>
                                {t("Gram Panchayat")}
                              </th>
                              <th style={{ minWidth: "180px", padding: "8px" }}>
                                {t("Constituency Name")}
                              </th>
                              <th style={{ minWidth: "150px", padding: "8px" }}>
                                {t("Proposal File Number")}
                              </th>
                              <th style={{ minWidth: "150px", padding: "8px" }}>
                                {t("Proposal Work Amount")}
                              </th>
                              <th style={{ minWidth: "100px", padding: "8px" }}>
                                {t("Class Of Work")}
                              </th>
                              <th style={{ minWidth: "220px", padding: "8px" }}>
                                {t("Type Of Work")}
                              </th>
                              <th style={{ minWidth: "130px", padding: "8px" }}>
                                {t("Road Category")}
                              </th>
                              <th style={{ minWidth: "130px", padding: "8px" }}>
                                {t("Road Number")}
                              </th>
                              <th style={{ minWidth: "130px", padding: "8px" }}>
                                {t("Proposed Length")}
                              </th>
                              <th style={{ minWidth: "200px", padding: "8px" }}>
                                {t("Remark")}
                              </th>
                            </tr>
                          </thead>

                          <tbody>
                            {currentBills?.length === 0 ? (
                              <tr>
                                <td
                                  colSpan="20"
                                  style={{
                                    textAlign: "center",
                                    padding: "10px",
                                    backgroundColor: "#f9f9f9",
                                  }}
                                >
                                  {t("No data available")}
                                </td>
                              </tr>
                            ) : (
                              currentBills?.map((proposal, index) => {
                                const bgColor =
                                  index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
                                return (
                                  <tr
                                    key={index}
                                    style={{
                                      backgroundColor: bgColor,
                                      fontSize: "12px",
                                      fontWeight: "500",
                                    }}
                                  >
                                    <td style={{ padding: "8px 8px" }}>
                                      {(currentPage - 1) * billsPerPage +
                                        index +
                                        1}
                                    </td>
                                    <td style={{ padding: "8px 8px" }}>
                                      {proposal.WorkName}
                                    </td>
                                    <td style={{ padding: "8px 8px" }}>
                                      {proposal.JOB_ID}
                                    </td>
                                    <td style={{ padding: "8px 8px" }}>
                                      {proposal.HeadCode}
                                    </td>
                                    <td style={{ padding: "8px 8px" }}>
                                      {proposal.ProposalYear}
                                    </td>
                                    <td style={{ padding: "8px 8px" }}>
                                      {proposal.District}
                                    </td>
                                    <td style={{ padding: "8px 8px" }}>
                                      {proposal.Taluka}
                                    </td>
                                    <td style={{ padding: "8px 8px" }}>
                                      {JSON.stringify(proposal.GramPanchayat)}
                                    </td>
                                    <td style={{ padding: "8px 8px" }}>
                                      {proposal.ConstituencyName}
                                    </td>
                                    <td style={{ padding: "8px 8px" }}>
                                      {proposal.ProposalFileNumber}
                                    </td>
                                    <td style={{ padding: "8px 8px" }}>
                                      {proposal.ProposalAmount}
                                    </td>
                                    <td style={{ padding: "8px 8px" }}>
                                      {proposal.workClass}
                                    </td>
                                    <td style={{ padding: "8px 8px" }}>
                                      {proposal.workType}
                                    </td>
                                    <td style={{ padding: "8px 8px" }}>
                                      {proposal.RoadCategory}
                                    </td>
                                    <td style={{ padding: "8px 8px" }}>
                                      {proposal.RoadNumber}
                                    </td>
                                    <td style={{ padding: "8px 8px" }}>
                                      {proposal.proposedLength}
                                    </td>
                                    <td style={{ padding: "8px 8px" }}>
                                      {proposal.Remark}
                                    </td>
                                  </tr>
                                );
                              })
                            )}
                          </tbody>
                        </table>
                      </div>

                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          marginTop: "20px",
                        }}
                      >
                        <p
                          className="text-gray-600 m-0"
                          style={{ fontSize: "14px" }}
                        >
                          {t("Showing")}{" "}
                          {filteredBills.length > 0
                            ? showAll
                              ? 1
                              : indexOfFirstBill + 1
                            : 0}{" "}
                          {t("to")}{" "}
                          {showAll
                            ? filteredBills.length
                            : Math.min(
                                indexOfLastBill,
                                filteredBills.length,
                              )}{" "}
                          {t("of")} {filteredBills.length} {t("entries")}
                        </p>

                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                          }}
                        >
                          <button
                            onClick={() => {
                              setShowAll(!showAll);
                              setCurrentPage(1);
                            }}
                            style={{
                              border: "none",
                              outline: "none",
                              cursor: "pointer",
                              padding: "8px 16px",
                              borderRadius: "20px",
                              fontSize: "13px",
                              fontWeight: "600",
                              color: "#fff",
                              background: showAll
                                ? "linear-gradient(135deg, #28a745, #20c997)"
                                : "linear-gradient(135deg, #0067ab, #0098d5)",
                              boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                              transition: "all 0.3s ease",
                            }}
                          >
                            {showAll ? "✓ Showing All" : "View All"}
                          </button>

                          {!showAll && (
                            <GooglePagination
                              currentPage={currentPage}
                              totalPages={totalPages}
                              onPageChange={setCurrentPage}
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  )}

                  <div className="col-12 elements">
                    <div className="row">
                      <div className="col-12 my-2">
                        <label>
                          {t("Supporting Document")}{" "}
                          <span className="text-danger fw-bold">*</span>
                        </label>
                      </div>
                      <div className="col-12">
                        <input
                          type="file"
                          className="form-control py-2"
                          id="ProposalCopy"
                          accept=".pdf,.jpg,.jpeg,.png"
                          required
                          onChange={handleSupportingDocUpload}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-12 ms-auto my-4">
                    <div className="row">
                      <div className="col-5"></div>
                      <div className="col-7">
                        <div
                          className="col-12"
                          style={{ display: "flex", gap: "10px" }}
                        >
                          <button
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              gap: "4px",
                              background:
                                "linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)",
                              width: "5rem",
                              height: "2rem",
                              fontSize: "18px",
                            }}
                            onClick={handleBulkSubmit}
                          >
                            <img src={submit} style={{ width: "15px" }} />{" "}
                            {t("Save")}
                          </button>

                          <button
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              gap: "4px",
                              backgroundColor: "#f1594c",
                              width: "6rem",
                              height: "2rem",
                              fontSize: "16px",
                            }}
                            onClick={(e) => CancelMapSubmission(e)}
                          >
                            {" "}
                            <img src={Cancel32} style={{ width: "17px" }} />
                            {t("Cancel")}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CreateProposalStatewise;
